const replaceWeightage = ({ selectedAssignments, weightage, selectorIndex }) =>
  selectedAssignments.map((item, itemIndex) => {
    if (itemIndex !== selectorIndex) {
      return item;
    }

    return {
      ...{ id: item.id },
      // remove weightage if user clear out the input field
      ...(weightage && { weightage }),
    };
  });

export default replaceWeightage;
